import { AxiosPromise } from 'axios';
import { instance } from '../../services';
import { IBadgeDetails } from './types';

const getBadge = (badgeNumber: string): AxiosPromise<IBadgeDetails> =>
  instance.get(`/api/badges/${badgeNumber}`);

export default getBadge;
